var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div>\n  <div class=\"coverage\"><span>{{ t('optimizeModalSuggestedRoutes', (routePlan.suggestedRoutesCoverage() | number : 0)) }}</span></div>\n  <div ng-repeat=\"suggestedRoute in suggestedRoutes\" ng-class=\"{ notOnRoute: ! suggestedRoute.name }\" class=\"suggested-route\"><span>{{ suggestedRoute.name ? suggestedRoute.name : t('suggestedRoutesModalNotOnRoute') }}</span><span>{{ suggestedRoute.customerCount }}</span></div>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/suggestedRoutes.jade
 ** module id = 109
 ** module chunks = 1
 **/